import { ProductType } from '@nx-customer-apps/components';
import { SystemType } from '@nx-customer-apps/shared/enums';

export const PRODUCT_TYPE_TO_TAG_TYPES = new Map<ProductType, SystemType[]>([
    // Heat pumps
    [ProductType.AirHeatPump, [SystemType.HeatPumpSystem]],
    [ProductType.GroundHeatPump, [SystemType.HeatPumpSystem]],
    [ProductType.WaterHeatPump, [SystemType.HeatPumpSystem]],
    [ProductType.HybridAirHeatPump, [SystemType.HeatPumpSystem]],
    // Boilers
    [ProductType.GasBoiler, [SystemType.GasBoilerSystem]],
    [ProductType.ElectricHeater, [SystemType.GasBoilerSystem]],
    [ProductType.HardwoodBoiler, [SystemType.GasBoilerSystem]],
    [ProductType.SoftwoodBoiler, [SystemType.GasBoilerSystem]],
    [ProductType.PelletBoiler, [SystemType.GasBoilerSystem]],
    [ProductType.HeatingOilBoiler, [SystemType.GasBoilerSystem]],
    // Photovoltaic
    [ProductType.PhotovoltaicModule, [SystemType.PhotovoltaicSystem]],
    [ProductType.PhotovoltaicBattery, [SystemType.PhotovoltaicSystem]],
    [ProductType.PhotovoltaicModuleInverter, [SystemType.PhotovoltaicSystem]],
    [ProductType.PhotovoltaicBatteryInverter, [SystemType.PhotovoltaicSystem]],
    [ProductType.PhotovoltaicHybridInverter, [SystemType.PhotovoltaicSystem]],
    [ProductType.PhotovoltaicAllInOneSystem, [SystemType.PhotovoltaicSystem]]
]);
